<template>
  <div class="d-flex flex-column mt-2">
    <div class="d-flex flex-row justify-content-between align-items-center my-2">
      <div v-if="file_name_enabled || upload_enabled" class="d-flex align-items-center">
        <h5
          v-if="file_name_enabled"
          id="file_name"
          class="d-inline-block mr-3 mb-0 text-truncate">
          {{ file_name }}
        </h5>
        <div v-if="upload_enabled" id="upload_control">
          <input
            type="file"
            id="assetsFieldHandle"
            class="d-none"
            @change="handleChangeFile"
            ref="file"
            :accept="allowed_file_types"
          />
        </div>
      </div>
      <div v-if="showDocumentHeader" class="header-document">
        <documents-document-header-vue
            :header_fields="document_header_options.header_fields"
            :tituloarticulo="document_header_options.tituloarticulo"
            :document_id="document_id"
        />
      </div>
      <div class="">
        <div class="row align-items-center mx-0">
          <div class="btnSofia px-4 py-2" v-if="!showDocumentHeader">
            <label
              for="assetsFieldHandle"
              id="another_file_label"
              class="mb-3 mb-md-0 cursor-pointer d-flex align-items-center justify-content-center br-xl-1 pr-3">
              <span v-if="uploading_file" id="uploading_file" class="text-white">
                {{ t("components.sofia_file_analyzer.loading") }}
              </span>
              <span class="loader-general fileUp" v-if="uploading_file"></span>
              <span v-else id="another_file" class="text-nowrap">
                <i class="fas fa-cloud-upload-alt pr-2"></i>
                <span>{{ t("components.sofia_file_analyzer.another_file") }}</span>
              </span>
            </label>
            <div
              class="d-flex align-items-center justify-content-center cursor-pointer ml-3"
              @click="new_document()"
              id="new_document_button">
              <i class="fas fa-plus pr-2"></i>
              <label class="text-center mb-0 cursor-pointer" >{{
                t("sofia.sofia_uploader.new_document")
              }}</label>
            </div>
          </div>
          <div class="d-flex align-items-end flex-column my-2 ml-2">
            <button
              id="save-button"
              class="btn btn-info ml-2 w-100"
              @click="handleSaveClick">
              <i class="fas fa-user-plus"></i>
              {{ t("components.sofia_file_analyzer.save_button") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-1">
      <div v-if="document_modified" class="alert alert-info mb-0 py-1" role="alert">
        <div class="d-flex flex-row align-items-center justify-content-center">
          <i class="fas fa-question-circle pr-2"></i>
          <p class="m-0">
            {{ t("components.sofia_file_analyzer.not_saved") }}
          </p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import mixins from 'common/mixins'
import { mapMutations } from 'vuex'
import SofiaUploaderMixin from "common/mixins/uploader_mixin";

export default {
  name: "sofia-toolbar-vue",
  mixins: [mixins.requests, mixins.translate, SofiaUploaderMixin],
  props: {
    options: { type: Array, default: () => [] },
    file_name: { type: String, default: "" },
    allowed_file_types: { type: String, default: "" },
    document_modified: { type: Boolean, default: false },
    document_header_options: { type: Object, default: () => { return {} } },
    document_id: { type: String, default: "" }
  },
  components: {
    'documents-document-header-vue': () => import(/* webpackChunkName: "[request]" */ "../documents/DocumentHeader.vue")
  },
  computed: {
    file_name_enabled() {
      if (!this.options) return false
      return this.options.includes("file_name")
    },
    upload_enabled() {
      if (!this.options) return false
      return this.options.includes("upload")
    },
    showDocumentHeader(){
      return Object.keys(this.document_header_options).length > 0;
    }
  },

  methods: {
    handleSaveClick() { this.$emit("save_document:clicked") },
    handleChangeFile(event) {
      let actual_file = event.target.files[0]
      this.update_current_file(actual_file)
    },
    ...mapMutations('sofia', ['update_current_file']),
  }
}
</script>
